import { useEffect, useState, useRef, useCallback } from 'react'
import API from 'api'
import { useDispatch } from 'react-redux'
import { setAdventureAvailability } from '../../../actions/adventure-actions'
import moment from 'moment'

export default function useAvailableDates(activityId, callback) {
  const dispatch = useDispatch()
  const [availabilities, setAvailabilites] = useState([])
  const [dates, setDates] = useState([])
  const [loading, setLoading] = useState(false)
  const loadedRanges = useRef([])
  const isFirstRequest = useRef(true)

  const fetchRange = useCallback((dateFrom, dateTo) => {
    const fromStr = moment(dateFrom).format('YYYY-MM-DD')
    const toStr = moment(dateTo).format('YYYY-MM-DD')

    const alreadyLoaded = loadedRanges.current.some(
      (range) => range.from <= fromStr && range.to >= toStr,
    )

    if(alreadyLoaded) { return }

    loadedRanges.current.push({ from: fromStr, to: toStr })
    setLoading(true)

    const isFirst = isFirstRequest.current
    if(isFirst) {
      isFirstRequest.current = false
    }

    API(
      `/api/adventure/v1/${activityId}/detail/availabilities/`,
      false,
      false,
      true,
    )
      .get({ dateFrom: fromStr, dateTo: toStr })
      .then((items) => {
        if(items.availabilities) {
          const newDates = items.availabilities.map((availability) => {
            if(availability.capacity) {
              return availability.date
            }
          })

          setAvailabilites((prev) => {
            const existingDates = new Set(prev.map((d) => d.date))
            const newItems = items.availabilities.filter((item) => !existingDates.has(item.date))
            return [...prev, ...newItems]
          })

          setDates((prev) => {
            const existing = new Set(prev)
            const newValidDates = newDates.filter((date) => date && !existing.has(date))
            return [...prev, ...newValidDates]
          })

          if(isFirst) {
            dispatch(setAdventureAvailability(items.availabilities))
            if(callback) {
              callback(newDates)
            }
          }
        }
      })
      .finally(() => {
        setLoading(false)
      })
  }, [activityId])

  useEffect(() => {
    const dateFrom = moment()
    const dateTo = moment().add(1, 'months').endOf('month')
    fetchRange(dateFrom, dateTo)
  }, [])

  return { dates, availabilities, loading, fetchRange }
}
